import React, { useEffect, useMemo, useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import { useNavigate, useParams } from "react-router-dom"
import {
  FaTicketAlt,
  FaRupeeSign,
  FaDownload,
  FaCheckCircle,
} from "react-icons/fa"
import TableContainer from "../../../components/Common/DataTableContainer"
import {
  fetchEventsTickets,
  fetchEventsTicketsExcel,
} from "../../../redux/actions/event"
import "./EventView.scss"
import StatsCard from "components/StatsCard"
import ActionDropdown from "components/ActionDropdown"

const EventView = () => {
  document.title = "Event Tickets View"

  const { url } = useParams()
  const history = useNavigate()
  const dispatch = useDispatch()

  const fetchEventTicketsState = useSelector(
    state => state.screens.event.fetchEventTickets
  ) //TODO
  const fetchEventTicketsExcelState = useSelector(
    state => state.screens.event.fetchEventTicketsExcel
  ) //TODO

  const [orderData, setOrderData] = useState([])

  console.log("orderData", orderData)

  const columns = useMemo(
    () => [
      {
        header: "Customer Name",
        accessorKey: "name",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Mobile No",
        accessorKey: "phone",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Email ID",
        accessorKey: "email",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "RazorPay Id",
        accessorKey: "razorpay_payment_id",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Payment amount",
        accessorKey: "total",
        enableColumnFilter: false,
        enableSorting: true,
      },

      {
        header: "No of Ticket",
        accessorKey: "total_tickets",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Date & Time",
        id: "date",
        accessorFn: row => row.date || row.created_at || "-",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Action",
        enableSorting: false,
        cell: info => {
          const row = info.row.original
          const rowId = row.enc_award_nomination_id

          return (
            <div className="d-flex align-items-center gap-2">
              <ActionDropdown buttonLabel="Actions">
                <button className="dropdown-item">Invoice</button>
                <button className="dropdown-item">Resend</button>
                <button className="dropdown-item">Regenerate</button>
              </ActionDropdown>
            </div>
          )
        },
      },
      // {
      //   header: "Payment Status",
      //   accessorKey: "paid",
      //   enableColumnFilter: false,
      //   enableSorting: true,
      //   cell: info => (info.getValue() === 1 ? "Paid" : "Unpaid"),
      // },
    ],
    []
  )

  // Calculate ticket and revenue stats
  const totalTickets = orderData.totalTickets || 0
  const paidTickets = orderData.paidTickets || 0
  const totalRevenue = orderData.totalPaidAmount || 0
  const freeTickets = orderData.freeTickets || 0
  const allBookedTickets = orderData.allBookedTickets || 0
  const tax = orderData.totalTaxAmount || 0

  // Download handlers using Redux dispatch
  const handleDownload = type => {
    let payload = {
      url,
      paid: type === "paid",
      startDate: "",
      endDate: "",
    }
    dispatch(fetchEventsTicketsExcel(payload))
  }

  useEffect(() => {
    if (fetchEventTicketsExcelState && fetchEventTicketsExcelState.event) {
      const link = document.createElement("a")
      link.href = fetchEventTicketsExcelState.event.data.fileUrl
      link.download = ""
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    } else if (
      fetchEventTicketsExcelState &&
      fetchEventTicketsExcelState.error
    ) {
      alert(
        fetchEventTicketsExcelState.error || "Export failed. Please try again."
      )
    }
  }, [fetchEventTicketsExcelState])

  useEffect(() => {
    if (!url) return
    let payload = { url, paid: true, startDate: "", endDate: "" }
    dispatch(fetchEventsTickets(payload))
  }, [url, dispatch])

  useEffect(() => {
    if (
      fetchEventTicketsState?.event &&
      Array.isArray(fetchEventTicketsState.event.data.data)
    ) {
      setOrderData(fetchEventTicketsState.event.data)
    } else if (fetchEventTicketsState?.error) {
      setOrderData([])
    }
  }, [fetchEventTicketsState])

  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="mb-3 pb-2"></div>
        <div className="d-flex flex-wrap align-items-center justify-content-between mb-4 pb-2">
          <h3 className="nom-title mb-0">Event Orders</h3>
          <ActionDropdown
            className="primary-button"
            buttonLabel="Event & Invoice"
          >
            <button className="dropdown-item" onClick={() => handleDownload("paid")}>
              <span>Event report (Excel)</span>
              <FaDownload />
            </button>
            <button className="dropdown-item">
              <span>Invoices Zip</span> <FaDownload />
            </button>
          </ActionDropdown>
        </div>

        <div className="stats-slider">
          <StatsCard
            title="Ticket Sold"
            value={allBookedTickets}
            icon={<FaCheckCircle />}
            bgClass="bg-success-soft"
            action={
              <button
                className="download-btn"
                onClick={() => handleDownload("paid")}
              >
                <FaDownload /> Download
              </button>
            }
          />

          <StatsCard
            title="Revenue"
            value={`₹${totalRevenue}`}
            icon={<FaRupeeSign />}
            bgClass="bg-warning-soft"
          />

          <StatsCard
            title="GST collected"
            value={`₹${tax}`}
            icon={<FaTicketAlt />}
            bgClass="bg-info-soft"
          />


          <StatsCard
            title="Payment Requests"
            value={totalTickets}
            icon={<FaTicketAlt />}
            bgClass="bg-primary-soft"
          />
        </div>

        {/* <Row className="g-4">
          <Col xl={3} lg={3} md={6} sm={12}>
            <Card className="stats-card">
              <CardBody>
                <div className="stats-header">
                  <div className="icon bg-primary-soft">
                    <FaTicketAlt />
                  </div>
                  <span className="stats-title">Registered Users</span>
                </div>
                <h2 className="stats-value">{totalTickets}</h2>
              </CardBody>
            </Card>
          </Col>
          <Col xl={3} lg={3} md={6} sm={12}>
            <Card className="stats-card">
              <CardBody>
                <div className="stats-header">
                  <div className="icon bg-warning-soft">
                    <FaRupeeSign />
                  </div>
                  <span className="stats-title">Revenue</span>
                </div>
                <h2 className="stats-value">₹{totalRevenue}</h2>
              </CardBody>
            </Card>
          </Col>
          <Col xl={3} lg={3} md={6} sm={12}>
            <Card className="stats-card">
              <CardBody>
                <div className="stats-header">
                  <div className="icon bg-success-soft">
                    <FaCheckCircle />
                  </div>
                  <span className="stats-title">All Tickets</span>
                </div>
                <h2 className="stats-value">{allBookedTickets}</h2>

                <Button
                  color="success"
                  size="sm"
                  className="download-btn"
                  onClick={() => handleDownload("paid")}
                >
                  <FaDownload className="me-2" />
                  Download
                </Button>
              </CardBody>
            </Card>
          </Col>
          <Col xl={3} lg={3} md={6} sm={12}>
            <Card className="stats-card">
              <CardBody>
                <div className="stats-header">
                  <div className="icon bg-info-soft">
                    <FaTicketAlt />
                  </div>
                  <span className="stats-title">Tickets</span>
                </div>

                <div className="stats-row">
                  <span>Paid</span>
                  <strong>{paidTickets}</strong>
                </div>

                <div className="stats-row">
                  <span>Discounted</span>
                  <strong>{freeTickets}</strong>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row> */}

        <div className="container-fluid">
          <TableContainer
            defaultPageSize={20}
            columns={columns}
            data={orderData.data || []}
            isGlobalFilter={true}
            isPagination={true}
            isCustomPageSize={true}
            SearchPlaceholder="Search records..."
            pagination="pagination"
            paginationWrapper="dataTables_paginate paging_simple_numbers"
            tableClass="table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
            theadClass="table-light"
            divClassName="table-responsive mb-4 nominee-tbl-wrapper"
          />
        </div>
      </div>
    </div>
  )
}

export default EventView
